export interface ApiErrorRaw {
  Critical?: boolean
  ErrorText?: string
  [key: string]: any
}

export interface NormalizedError {
  critical: boolean
  text: string
}

export const isApiErrorArray = (v: unknown): v is ApiErrorRaw[] => {
  return (
    Array.isArray(v) &&
    v.every(
      e =>
        e &&
        typeof e === 'object' &&
        ('ErrorText' in (e as any) || 'errorText' in (e as any)),
    )
  )
}

export const extractMessages = (payload: unknown): string[] => {
  if (!payload) return []

  if (isApiErrorArray(payload)) {
    return payload.map(e => String(e.ErrorText ?? e.errorText ?? ''))
  }

  if (payload instanceof Error) return [payload.message]

  if (typeof payload === 'string') return [payload]

  // unknown shape — try to stringify useful fields
  try {
    return [JSON.stringify(payload)]
  } catch {
    return [String(payload)]
  }
}

export const mapToNormalized = (payload: unknown): NormalizedError[] => {
  if (!payload) return []

  if (isApiErrorArray(payload)) {
    return payload.map(e => ({
      critical: Boolean(e.Critical ?? e.critical),
      text: String(e.ErrorText ?? e.errorText ?? ''),
    }))
  }

  if (payload instanceof Error)
    return [{ critical: false, text: payload.message }]

  if (typeof payload === 'string') return [{ critical: false, text: payload }]

  try {
    return [{ critical: false, text: JSON.stringify(payload) }]
  } catch {
    return [{ critical: false, text: String(payload) }]
  }
}

/**
 * Return the first message found in the payload (or null if none).
 */
export const getFirstMessage = (payload: unknown): string | null => {
  const msgs = extractMessages(payload)
  if (msgs && msgs.length > 0) return msgs[0]
  return null
}
